import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'giq-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent {
  public message: string = '';
  constructor(public authService: AuthService) {
    if (authService.sesExpired) {
      this.message = 'Your session expired';
    }
  }
}
